import { Button } from "@/components/ui/button";
import styles from "./styles.module.scss";
import { cn } from "@/lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";


interface Props { currentPage: number, totalPages: number, onPageChange: (page: number) => void }

export const UiPagination = ({ currentPage, totalPages, onPageChange }: Props) => {

	if (totalPages <= 1) return null;

	return <div className={styles.pagination}>
		<Button
			variant="outline"
			className={cn(styles.pagination__btn, {
				[styles.pagination__btn_disabled]: currentPage === 1,
			})}
			onClick={() => currentPage > 1 && onPageChange(currentPage - 1)} disabled={currentPage === 1}>
			<ChevronLeft />
		</Button>

		<div className={styles.pagination__numbers}>
			{Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
				// Display logic for page numbers
				let pageToShow: number;

				if (totalPages <= 5) {
					// If we have 5 or fewer pages, show all pages
					pageToShow = i + 1;
				} else {
					// For more than 5 pages, create a sliding window
					if (currentPage <= 3) {
						// At the beginning, show pages 1-5
						pageToShow = i + 1;
					} else if (currentPage >= totalPages - 2) {
						// At the end, show the last 5 pages
						pageToShow = totalPages - 4 + i;
					} else {
						// In the middle, show currentPage-2 to currentPage+2
						pageToShow = currentPage - 2 + i;
					}
				}

				return <Button key={`page-${pageToShow}`}
					onClick={() => onPageChange(pageToShow)}
					variant="outline"
					className={cn(styles.pagination__number, {
						[styles.pagination__number_active]: currentPage === pageToShow,
					})}

				>
					{pageToShow}
				</Button>
			})}
		</div>

		<Button
			variant="outline"
			className={cn(styles.pagination__btn, {
				[styles.pagination__btn_disabled]: currentPage === totalPages,
			})}
			onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
			<ChevronRight />
		</Button>
	</div>
}